import { render, staticRenderFns } from "./FilePreviewBody.vue?vue&type=template&id=5721d460&scoped=true"
import script from "./FilePreviewBody.vue?vue&type=script&lang=js"
export * from "./FilePreviewBody.vue?vue&type=script&lang=js"
import style0 from "./FilePreviewBody.vue?vue&type=style&index=0&id=5721d460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721d460",
  null
  
)

export default component.exports